import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type SelectedChildState = {
  childId: number | null;
};

const initialState: SelectedChildState = {
  childId: null,
};

const selectedChildSlice = createSlice({
  name: "selectedChild",
  initialState,
  reducers: {
    onSelectChild(state, { payload }: PayloadAction<number>) {
      state.childId = payload;
    },
    onResetSelectedChild() {
      return initialState;
    },
  },
});

export const { onSelectChild, onResetSelectedChild } =
  selectedChildSlice.actions;
export const selectedChildReducer = selectedChildSlice.reducer;
